/**
 * Shared time formatting helpers for call comments features.
 */

export const timeFmt = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

type Dateish = string | number | Date;

export function formatTime(ts?: Dateish): string {
  if (!ts) {
    return '';
  }
  const date = new Date(ts);
  if (isNaN(date.getTime())) {
    return '';
  }
  // Some engines/locales may insert non-breaking or narrow spaces.
  // Strip all common Unicode space characters to avoid odd gaps like "9:4 1am".
  return timeFmt
    .format(date)
    .replace(/[\s\u00A0\u2000-\u200B\u202F\u205F\u3000]/g, '')
    .toLowerCase();
}

export function formatRange(start?: Dateish, end?: Dateish): string {
  const s = formatTime(start);
  const e = formatTime(end);
  if (!s && !e) {
    return '';
  }
  if (s && e) {
    return `${s} - ${e}`;
  }
  return s || e;
}
